import { createClient } from '@/clients/http'

function mapLocation (location) {
  return {
    locationId: location.locationId,
    legacyLocationId: null,
    legacyPracticeId: null,
    name: location.name,
    address1: location.address1 || null,
    address2: location.address2 || null,
    city: location.city || null,
    state: location.state || null,
    zip: location.zip != null ? String(location.zip) : null
  }
}

function mapProvider (provider) {
  return {
    providerId: provider.providerId,
    legacyProviderId: null,
    firstName: provider.firstName || '',
    middleName: provider.middleName || '',
    lastName: provider.lastName || '',
    photoUrl: provider.photoUrl || ''
  }
}

export default class WebsiteMgmtServiceClient {
  constructor (practiceUuid) {
    this.client = createClient(process.env.VUE_APP_PO_API_DOMAIN)
    this.practiceUuid = practiceUuid
  }

  async getLocations () {
    const { data } = await this.client.get(`/api/practices/${encodeURIComponent(this.practiceUuid)}/locations`)
    const locations = data.locations || []
    return { data: { locations: locations.map(mapLocation) } }
  }

  async getProviders (locationUuid) {
    const { data } = await this.client.get(
      `/api/practices/${encodeURIComponent(this.practiceUuid)}/locations/${encodeURIComponent(locationUuid)}/providers`
    )
    const providers = data.providers || []
    return { data: { providers: providers.map(mapProvider) } }
  }

  submitReview ({ reviewerName, reviewerEmail, rating, reviewType, content, practiceUuid, locationId, providerId }) {
    return this.client.post(`/api/practices/${encodeURIComponent(this.practiceUuid)}/reviews`, {
      reviewer_name: reviewerName,
      reviewer_email: reviewerEmail,
      review_type: reviewType,
      rating,
      content,
      practice_id: practiceUuid,
      location_id: locationId,
      provider_id: providerId
    })
  }
}
